import { Modal, Space, Table, Tooltip, Input, Popconfirm, Alert, Select, Button, message } from "antd";
import React from "react";
import { withRouter } from "../../components/withRouter";
import Header from "../../components/Header";
import { LockOutlined, EditOutlined } from "@ant-design/icons";
import { openNotification } from "../../functions";

const { Option } = Select;

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalUser: false,
      users: [],
      editUser: false,
      userModal: false,
      editUser_id: 0,

      userSurname: "",
      userName: "",
      userRole: 2,
      userLogin: "",
      userPassword: "",
      userRepeatPassword: "",
    };
    this.customNavFunction = this.customNavFunction.bind(this);
  }

  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
  };

  customNavFunction() {
    return this.props.navigate("/");
  }

  getUsers() {
    fetch(`https://bot.weddingchelny.ru/api/adm/users`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "GET",
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({ users: res.data, editUser: false });
        }
      }
    });
  }

  ChangeInputValue = (e) => {
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [name]: value });
  };

  ChangeInputPrice = (e) => {
    let regex = /^(0|[1-9][0-9]*)(\.[0-9]{0,2})?$/;
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (regex.test(value) || value == "") {
      this.setState({ [name]: value });
    }
  };

  createUser() {
    if (this.state.editUser == true) {
      if (
        this.state.userSurname.trim() == "" ||
        this.state.userName.trim() == "" ||
        this.state.userLogin.trim() == ""
      ) {
        return message.error("Пожалуйста, заполните все поля", 3);
      }
    } else {
      if (
        this.state.userSurname.trim() == "" ||
        this.state.userName.trim() == "" ||
        this.state.userLogin.trim() == "" ||
        this.state.userPassword.trim() == "" ||
        this.state.userRepeatPassword.trim() == ""
      ) {
        return message.error("Пожалуйста, заполните все поля", 3);
      }
    }

    if (this.state.editUser == false) {
      if (this.state.userPassword.trim() !== this.state.userRepeatPassword.trim()) {
        return message.error('Проверьте правильность пароля в строках "Пароль" и "Повторите пароль"', 3);
      }
    }

    if (this.state.editUser == true) {
      fetch(`https://bot.weddingchelny.ru/api/adm/users/checklogin`, {
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer " + localStorage.getItem("ttk"),
        }),
        method: "POST",
        body: JSON.stringify({
          login: this.state.userLogin,
          edit: true,
          id: this.state.editUser_id,
        }),
      }).then(async (response) => {
        if (response.status == 401) {
          localStorage.clear();
          this.customNavFunction();
        } else {
          let res = await response.json();
          if (res.error) {
            openNotification("Ошибка", res.error, 1, 3.0);
          } else {
            if (res.status == "ok") {
              fetch(`https://bot.weddingchelny.ru/api/adm/users/` + this.state.editUser_id, {
                headers: new Headers({
                  "Content-Type": "application/json; charset=utf-8",
                  Authorization: "Bearer " + localStorage.getItem("ttk"),
                }),
                method: "PATCH",
                body: JSON.stringify({
                  name: this.state.userName,
                  surname: this.state.userSurname,
                  role: this.state.userRole,
                  login: this.state.userLogin,
                }),
              }).then(async (response) => {
                if (response.status == 401) {
                  localStorage.clear();
                  this.customNavFunction();
                } else {
                  let res = await response.json();
                  if (res.error) {
                    openNotification("Ошибка", res.error, 1, 3.0);
                  } else {
                    this.setState({
                      userName: "",
                      userSurname: "",
                      userRole: "2",
                      userLogin: "",
                      userPassword: "",
                      userRepeatPassword: "",
                      userModal: false,
                      editUser: false,
                      editUser_id: 0,
                    });
                    this.getUsers();
                  }
                }
              });
            } else {
              openNotification("Ошибка", "Пользователь с таким логином уже существует", 1, 3.0);
            }
          }
        }
      });
    } else {
      fetch(`https://bot.weddingchelny.ru/api/adm/users/checklogin`, {
        headers: new Headers({
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer " + localStorage.getItem("ttk"),
        }),
        method: "POST",
        body: JSON.stringify({
          login: this.state.userLogin,
        }),
      }).then(async (response) => {
        if (response.status == 401) {
          localStorage.clear();
          this.customNavFunction();
        } else {
          let res = await response.json();
          if (res.error) {
            openNotification("Ошибка", res.error, 1, 3.0);
          } else {
            if (res.status == "ok") {
              fetch(`https://bot.weddingchelny.ru/api/adm/users`, {
                headers: new Headers({
                  "Content-Type": "application/json; charset=utf-8",
                  Authorization: "Bearer " + localStorage.getItem("ttk"),
                }),
                method: "POST",
                body: JSON.stringify({
                  name: this.state.userName,
                  surname: this.state.userSurname,
                  role: this.state.userRole,
                  login: this.state.userLogin,
                  password: this.state.userPassword,
                }),
              }).then(async (response) => {
                if (response.status == 401) {
                  localStorage.clear();
                  this.customNavFunction();
                } else {
                  let res = await response.json();
                  if (res.error) {
                    openNotification("Ошибка", res.error, 1, 3.0);
                  } else {
                    this.setState({
                      userName: "",
                      userSurname: "",
                      userRole: "2",
                      userLogin: "",
                      userPassword: "",
                      userRepeatPassword: "",
                      userModal: false,
                      editUser_id: 0,
                    });
                    this.getUsers();
                  }
                }
              });
            } else {
              openNotification("Ошибка", "Пользователь с таким логином уже существует", 1, 3.0);
            }
          }
        }
      });
    }
  }

  editPasswordAction() {
    if (
      this.state.userPassword.trim() !== this.state.userRepeatPassword.trim() ||
      this.state.userRepeatPassword.trim() == "" ||
      this.state.userPassword.trim() == ""
    ) {
      return message.error('Проверьте правильность пароля в строках "Пароль" и "Повторите пароль"', 3);
    }
    fetch(`https://bot.weddingchelny.ru/api/adm/users/password`, {
      headers: new Headers({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("ttk"),
      }),
      method: "PATCH",
      body: JSON.stringify({
        password: this.state.userPassword,
        id: this.state.editUser_id,
      }),
    }).then(async (response) => {
      if (response.status == 401) {
        localStorage.clear();
        this.customNavFunction();
      } else {
        let res = await response.json();
        if (res.error) {
          openNotification("Ошибка", res.error, 1, 3.0);
        } else {
          this.setState({
            userPassword: "",
            userRepeatPassword: "",
            editUser_id: 0,
            editPasswordModal: false,
          });
          this.getUsers();
        }
      }
    });
  }

  render() {
    const columns = [
      {
        title: "Фамилия",
        dataIndex: "surname",
        key: "surname",
      },
      {
        title: "Имя",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Роль",
        dataIndex: "role",
        key: "role",
        render: (text, record) => {
          return record.role == "1"
            ? "Администратор"
            : record.role == "2"
              ? "Продавец"
              : record.role == "99"
                ? "Владелец"
                : "Неизвестно";
        },
      },
      {
        title: "Логин",
        dataIndex: "login",
        key: "login",
      },
      {
        title: "Действия",
        dataIndex: "events",
        key: "events",
        render: (text, record) => {
          return (
            <Space size="large">
              {record.role == "99" ? (
                ""
              ) : (
                <Tooltip title="Изменить данные">
                  <EditOutlined
                    onClick={() => {
                      this.setState({
                        editUser: true,
                        userName: record.name,
                        userSurname: record.surname,
                        userRole: record.role.toString(),
                        userLogin: record.login,
                        userModal: true,
                        editUser_id: record.key,
                      });
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
              )}
              <Tooltip title="Изменить пароль">
                <LockOutlined
                  onClick={() => {
                    this.setState({ editUser_id: record.key, editPasswordModal: true });
                  }}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            </Space>
          );
        },
      },
    ];

    return (
      <div>
        <Header />
        <div className="container">
          <Space direction={window.innerWidth > 650 ? "horizontal" : "vertical"}>
            <h1>Пользователи</h1>
            <Button
              onClick={() => {
                this.setState({
                  editUser: false,
                  userName: "",
                  userSurname: "",
                  userRole: "2",
                  userLogin: "",
                  userPassword: "",
                  userRepeatPassword: "",
                  userModal: true,
                  editUser_id: 0,
                });
              }}
              type="primary"
            >
              Создать нового пользователя
            </Button>
          </Space>
          {window.innerWidth > 650 ? (
            <Table columns={columns} dataSource={this.state.users} />
          ) : (
            this.state.users.map((record) => {
              return (
                <div className="sale_item">
                  <div>Фамилия: {record.surname}</div>
                  <div>Имя: {record.name}</div>
                  <div>
                    Роль:{" "}
                    {record.role == "1"
                      ? "Администратор"
                      : record.role == "2"
                        ? "Продавец"
                        : record.role == "99"
                          ? "Владелец"
                          : "Неизвестно"}
                  </div>
                  <div>Логин: {record.login}</div>
                  <div>
                    Действия: <br />
                    <Space size="large">
                      {record.role == "99" ? (
                        ""
                      ) : (
                        <button
                          onClick={() => {
                            this.setState({
                              editUser: true,
                              userName: record.name,
                              userSurname: record.surname,
                              userRole: record.role.toString(),
                              userLogin: record.login,
                              userModal: true,
                              editUser_id: record.key,
                            });
                          }}
                        >
                          <EditOutlined style={{ cursor: "pointer" }} /> Изменить данные
                        </button>
                      )}
                      <button
                        onClick={() => {
                          this.setState({ editUser_id: record.key, editPasswordModal: true });
                        }}
                      >
                        <LockOutlined style={{ cursor: "pointer" }} /> Изменить пароль
                      </button>
                    </Space>
                  </div>
                </div>
              );
            })
          )}

          <Modal
            title={"Пользователь"}
            open={this.state.userModal}
            onOk={() => {
              this.createUser();
            }}
            onCancel={() => {
              this.setState({
                editUser: false,
                userName: "",
                userSurname: "",
                userRole: "2",
                userLogin: "",
                userPassword: "",
                userRepeatPassword: "",
                userModal: false,
                editUser_id: 0,
              });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            <Alert
              message="Будьте внимательны, пробелы в начале и в конце каждого пункта будут удалены!"
              type="info"
              showIcon
              style={{ marginBottom: 20 }}
            />
            <Space direction="vertical" style={{ width: "100%" }}>
              <div>
                <div>Фамилия</div>
                <Input name="userSurname" value={this.state.userSurname} onChange={this.ChangeInputValue.bind(this)} />
              </div>
              <div>
                <div>Имя</div>
                <Input name="userName" value={this.state.userName} onChange={this.ChangeInputValue.bind(this)} />
              </div>
              <div>
                <div>Роль</div>
                <Select
                  value={this.state.userRole}
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    this.setState({ userRole: e });
                  }}
                >
                  <Option value="1">Администратор</Option>
                  <Option value="2">Продавец</Option>
                </Select>
              </div>
              <div>
                <div>Логин</div>
                <Input name="userLogin" value={this.state.userLogin} onChange={this.ChangeInputValue.bind(this)} />
              </div>
              {this.state.editUser == false ? (
                <div>
                  <div>
                    <div>Пароль</div>
                    <Input
                      name="userPassword"
                      value={this.state.userPassword}
                      onChange={this.ChangeInputValue.bind(this)}
                    />
                  </div>
                  <div>
                    <div>Повторите пароль</div>
                    <Input
                      name="userRepeatPassword"
                      value={this.state.userRepeatPassword}
                      onChange={this.ChangeInputValue.bind(this)}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </Space>
          </Modal>

          <Modal
            title={"Смена пароля"}
            open={this.state.editPasswordModal}
            onOk={() => {
              this.editPasswordAction();
            }}
            onCancel={() => {
              this.setState({
                editUser: false,
                userName: "",
                userSurname: "",
                userRole: "2",
                userLogin: "",
                userPassword: "",
                userRepeatPassword: "",
                editPasswordModal: false,
                editUser_id: 0,
              });
            }}
            okText="Сохранить"
            cancelText="Отмена"
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              {this.state.editUser == false ? (
                <div>
                  <div>
                    <div>Пароль</div>
                    <Input
                      name="userPassword"
                      value={this.state.userPassword}
                      onChange={this.ChangeInputValue.bind(this)}
                    />
                  </div>
                  <div>
                    <div>Повторите пароль</div>
                    <Input
                      name="userRepeatPassword"
                      value={this.state.userRepeatPassword}
                      onChange={this.ChangeInputValue.bind(this)}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </Space>
          </Modal>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.getUsers();
  }
}

export default withRouter(Users);
